/**
 * Created by Ning Jiang on 2021-05-27.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData, ReelState} from "../../../core/reel/ReelState";
import {KarenSoundManager} from "../../sound/KarenSoundManager";
import {Karen} from "../../Karen";
import {KarenSoundConfig} from "../../sound/KarenSoundConfig";
import {NolimitHowl} from "@nolimitcity/slot-audio/bin/NolimitHowl";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {KarenSymbolName} from "../../symbol/KarenSymbolConfig";

export class ReelStopSoundController extends ReelStopPresentationController {

    private _spinStates: boolean[];

    constructor() {
        super('ReelStopSoundController');
    }

    public async start(): Promise<any> {
        this._spinStates = Karen.reels.map(reel => reel.reelState === ReelState.SPIN);
        await super.start();
    }

    protected onReelBounce(data: IReelStateEventData): Promise<any> {
        const soundName: string = KarenSoundConfig.REELS_LANDING.next();
        const sound: NolimitHowl | undefined = KarenSoundManager.playSoundEffect(soundName);
        if (sound) {
            Logger.logDev("sound: starting Sound", soundName, "for reel:", data.reelId);
            sound.player.stereo(KarenSoundManager.davidPanningReelStop[data.reelId]);
        }
        this.playSoundsOnSymbolsLanding(data.reelId);
        if (data.reelId === 5) {
            KarenSoundManager.stopSoundEffect(KarenSoundConfig.REELS_SPINNING);
        }
        return super.onReelBounce(data);
    }

    protected onReelStopped(data: IReelStateEventData): Promise<void> {
        this._spinStates[data.reelId] = false;
        return super.onReelStopped(data);
    }

    private playSoundsOnSymbolsLanding(reelId: number): void {
        let reelData: string[] = Karen.model.gameData.reels[reelId];
        let soundCheck: boolean[] = [false, false];
        for (let idx: number = 1; idx <= Karen.model.gameData.evaluatedArea[reelId].length; idx++) {
            if (reelData[idx] === KarenSymbolName.XW && !soundCheck[0]) {
                KarenSoundManager.playSoundEffect(KarenSoundConfig.X_WAYS_LAND);
                soundCheck[0] = true;
            }

            if (reelData[idx] === KarenSymbolName.INFXW && !soundCheck[1]) {
                KarenSoundManager.playSoundEffect(KarenSoundConfig.xWaysInfectiousLand);
                soundCheck[1] = true;
            }
        }
        if (Karen.model.parsedGameData.doReelNudge && reelId === 5) {
            KarenSoundManager.playSoundEffect(KarenSoundConfig.xNudgeLand);
        }
    }
}
